export default {
  "content": "<g fill-rule=\"evenodd\"><rect fill=\"var(--bv-color-teal-4)\" width=\"142\" height=\"356\" x=\"12\" y=\"121\" rx=\"71\"/><rect fill=\"var(--bv-color-indigo-4)\" width=\"127\" height=\"443\" x=\"198\" y=\"34\" rx=\"63.5\"/><rect fill=\"var(--bv-color-purple-4)\" width=\"130\" height=\"283\" x=\"369\" y=\"194\" rx=\"65\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 512 512"
  }
};